import { httpGet, httpPost } from "@/request/http";

let path = "/directoryFoodKinds";

export default {
  getPages(dTO) {
    return httpGet(`${path}/pages`, dTO);
  },
  getFoodKinds(id) {
    return httpGet(`${path}/directorys/${id}/foodKinds`);
  },
  add(items) {
    return httpPost(`${path}/addbatch`, items);
  },
  remove(items) {
    return httpPost(`${path}/deletebatch`, items);
  },
};
